import { render, staticRenderFns } from "./GridItem.vue?vue&type=template&id=205cbd94&scoped=true&"
import script from "./GridItem.vue?vue&type=script&lang=js&"
export * from "./GridItem.vue?vue&type=script&lang=js&"
import style0 from "./GridItem.vue?vue&type=style&index=0&id=205cbd94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205cbd94",
  null
  
)

export default component.exports